import { platform, soundService } from "@aceroll/core";

const SFX = {
    UI_BET: 'changing_bet',
    UI_SPIN: 'slot_spin'
};

const AMBIENTS = {
    LEVEL_1: 'level_1',
    LEVEL_2: 'level_2',
    LEVEL_3: 'level_3',
    LEVEL_4: 'level_4',
    BONUS: 'bonus_level_0',
    BONUS_SPLASH: 'bonus_splash'
};

class Sounds {
    levelPlaying = false;
    currentAmbient = '';
    baseAmbient = AMBIENTS.LEVEL_1;

    constructor() {
        this.activeSound = '';
        this.baseAmbient = AMBIENTS.LEVEL_1;
    }

    fadeOutCurrentAmbient(duration) {
        soundService.fadeOut(this.currentAmbient, duration);
    }

    setBaseAmbient(duration) {
        this.currentAmbient = AMBIENTS.LEVEL_1;
        soundService.fadeIn(AMBIENTS.LEVEL_1, duration, 0.15);
    }

    setBonusSplashAmbient(duration) {
        this.currentAmbient = AMBIENTS.BONUS_SPLASH;
        soundService.fadeIn(AMBIENTS.BONUS_SPLASH, duration, 0.15);
    }

    setBonusAmbient(duration) {
        this.currentAmbient = AMBIENTS.BONUS;
        soundService.fadeIn(AMBIENTS.BONUS, duration, 0.15);
    }

    playLevelAmbient(level) {
        const soundName = AMBIENTS[`LEVEL_${level}`];
        this.currentAmbient = soundName;

        soundService.play(soundName);

        this.levelPlaying = true;
    }

    subscribeUISounds() {
        platform.onUiBetChange(soundService.play.bind(soundService), SFX.UI_BET);
        platform.onUiBetPlace(() => {
            soundService.play(SFX.UI_SPIN);
        });
    }
}

export default new Sounds();
